exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".volume-of-activity[data-v-7893228f] {\n  padding: 92px 0;\n}\n@media screen and (max-width: 576px) {\n.volume-of-activity[data-v-7893228f] {\n    padding: 42px 0;\n}\n}\n.activity__title[data-v-7893228f] {\n  margin-bottom: 47px;\n}\n@media screen and (max-width: 576px) {\n.activity__title[data-v-7893228f] .text__inner {\n    font-size: 24px !important;\n}\n}\n@media screen and (max-width: 576px) {\n.activity__one-volume[data-v-7893228f]:last-child {\n    margin-bottom: 0 !important;\n}\n}\n.text-center[data-v-7893228f] {\n  text-align: center;\n}", ""]);

// exports
